'use strict';

var processInclude = require('base/util');

$(() => {
    processInclude(require('./account/account'));
    processInclude(require('./account/deactivateAccount'));
    processInclude(require('./account/affiliateAccount'));
});
